import { render, staticRenderFns } from "./ownershipStructure.vue?vue&type=template&id=0dd5e6a7&scoped=true&"
import script from "./ownershipStructure.vue?vue&type=script&lang=js&"
export * from "./ownershipStructure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd5e6a7",
  null
  
)

export default component.exports